/*
 * @Description: 初始化项目数据，防止刷新丢失
 * @Date: 2021-10-28 16:51:32
 */

export default {
  created() {
    const { projectId, type } = this.$route.query;
    if (
      projectId &&
      type &&
      !this.$store.state.dataAnalysis.projectDetail.projectId
    ) {
      // this.initProject(this.$route.query);
      this.$store.dispatch('dataAnalysis/getProjectInfoById', {
        query: { projectId },
        projectItem: { type }
      });
    }
  }
};
